export default __webpack_public_path__ + "public/assets/images/9147d70fee78ff35189c73e30c9cf860.png";